import { LoanOfferItem } from '@shared/sec-loans'

import { WizardContext, WizardStep } from './wizard/wizardMachine'

export enum QueryParams {
  LoanOfferId = 'loanOfferId',
}

export interface FormContextValue extends WizardContext {
  step: WizardStep
  proceed: () => void
  goBack: () => void
  goBackToStatus: () => void
  exit: () => Promise<void>
  exitWithConfirmDialog: () => void
}

export type ExistingLoanOfferContext = FormContextValue & Pick<Required<WizardContext>, 'loanOffer'>

export type OnAutomaticOfferData = {
  loanOffer: LoanOfferItem
}
